import { createSelector } from 'reselect';

const searchSelector = ({ search }) => search || {};

const querySelector = createSelector(searchSelector, ({ query }) => query || {});
const keywordsSelector: (state: ReduxState) => ?string = createSelector(
  querySelector,
  ({ keywords }) => keywords,
);

export { keywordsSelector };
